export const COMMON_INITIAL_SCREENS = [
  "salon",
  "dashboard",
  "todos",
  "schedule",
] as const;
export const MASTER_INITIAL_SCREENS = [
  ...COMMON_INITIAL_SCREENS,
  "profile",
  "clients",
  "orders",
] as const;

export type tInitialScreen = (typeof MASTER_INITIAL_SCREENS)[number];

